import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const ahoiCustomerGroup = 'ahoi';
export const customerGroup = ahoiCustomerGroup;

const supportEmail = {
	ahoi: 'ahoi@smoothr.de',
};
const firebaseConfig = {
	ahoi: {
		apiKey: 'AIzaSyBbGBlbK3Xy5zg8RNWnVGTu9YM57B9XnCU',
		authDomain: 'ahoi-2d14b.firebaseapp.com',
		projectId: 'ahoi-2d14b',
		storageBucket: 'ahoi-2d14b.firebasestorage.app',
		messagingSenderId: '20804175012',
		appId: '1:20804175012:web:41e0d258f3535870ca5231',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDAdrZ5vG1_A-5rChcnhh6UQjfhX1OI9QE',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['en'],
	gaId: '',
	hasRecommendations: true,
	apiUrl: 'https://ahoi.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: true,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
};
